import { FC } from 'react';
import { WeeeIcon } from '@/components/common/Icon';
import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';

import styles from './index.module.scss';

type Props = {
  className?: string;
  text?: string;
};

const NoReceiver: FC<Props> = ({ className, text }) => {
  const { t, lang } = useTranslation('common');
  return (
    <div className={classNames(styles.noReceiverContainer, className)}>
      <div className={styles.icon}>
        <WeeeIcon className={styles.noIcon} type="iconselected3"></WeeeIcon>
      </div>
      <div dangerouslySetInnerHTML={{ __html: text ? text : t('share_progress_no_revicer') }}></div>
    </div>
  );
};

export default NoReceiver;
